import React from "react";

const SkeletonRow = ({ index = 0, columnCount = 6 }) => (
  <tr
    className="row"
    style={{ animationDelay: `${index * 0.1}s`, width: "100%" }}
  >
    {Array.from({ length: columnCount }).map((_, i) => (
      <td key={i} className="cell" style={{ marginRight: "8px" }}>
        <div className="skeleton" />
      </td>
    ))}
  </tr>
);

export default SkeletonRow;
